// @ts-nocheck
import { useEffect, useMemo, useState } from 'react'
import { AgGridReact } from '@ag-grid-community/react'

import api from '../api/api'
import { getGraphDayState, getRealBsiItems } from '../utils/graphDay'


function WellMonthAgGrid({ wellId, orgId, onSelectDate }) {
  const [graphData, setGraphData] = useState(null)
  const [selectedDay, setSelectedDay] = useState(null)
  const [bsiDetails, setBsiDetails] = useState(null)

  useEffect(() => {
    if (!wellId) return

    api.get('well-current-graph/', {
      params: {
        well: wellId,
        org: orgId || undefined,
      },
    })
      .then((res) => {
        setGraphData(res.data)
        setSelectedDay(null)
      })
      .catch((err) => console.error(err))
  }, [wellId, orgId])

  const columnDefs = useMemo(() => {
    const daysColumns = Array.from({ length: 31 }, (_, index) => {
      const day = index + 1

      return {
        headerName: String(day),
        field: `d${day}`,
        width: 30,
        minWidth: 30,
        maxWidth: 30,
        headerClass: 'graph-day-header',
        cellClass: 'graph-day-cell',
        suppressHeaderMenuButton: true,
        suppressHeaderFilterButton: true,
        suppressHeaderContextMenu: true,
        suppressMenu: true,
        menuTabs: [],
        filter: false,
        sortable: false,
        cellStyle: (params) => {

          const isSelected = selectedDay === day

          const value = params.value

          const dayState = getGraphDayState(value)

          // выбранный день КС
          if (isSelected) {
            return {
              background: '#1976d2',
              color: '#fff',
              textAlign: 'center',
              cursor: 'pointer',
              border: '1px solid #1565c0',
              fontWeight: 'bold',
            }
          }

          if (dayState.kind === 'done_planned' || dayState.kind === 'done') {
            return {
              background: '#81c784',
              color: '#1b5e20',
              textAlign: 'center',
              cursor: 'pointer',
              border: '1px solid #66bb6a',
              fontWeight: 'bold',
            }
          }

          if (dayState.kind === 'manual_planned') {
            return {
              background: '#2e7d32',
              color: '#ffffff',
              textAlign: 'center',
              cursor: 'pointer',
              border: '1px solid #1b5e20',
              fontWeight: 'bold',
            }
          }

          if (dayState.kind === 'manual_outside_plan') {
            return {
              background: 'linear-gradient(135deg, #2e7d32 0 49%, #fff 50% 100%)',
              color: '#1b5e20',
              textAlign: 'center',
              cursor: 'pointer',
              border: '1px solid #1b5e20',
              fontWeight: 'bold',
            }
          }

          if (dayState.kind === 'done_outside_plan') {
            return {
              background: 'linear-gradient(135deg, #81c784 0 49%, #fff 50% 100%)',
              color: '#1b5e20',
              textAlign: 'center',
              cursor: 'pointer',
              border: '1px solid #66bb6a',
              fontWeight: 'bold',
            }
          }

          if (dayState.kind === 'ppk_pending') {
            return {
              background: 'linear-gradient(135deg, #fff176 0 49%, #66bb6a 50% 100%)',
              color: '#3e5f16',
              textAlign: 'center',
              cursor: 'pointer',
              border: '1px solid #9ccc65',
              fontWeight: 'bold',
            }
          }

          if (dayState.kind === 'no_pass') {
            return {
              background: '#fff176',
              color: '#795548',
              textAlign: 'center',
              cursor: 'pointer',
              border: '1px solid #fdd835',
              fontWeight: 'bold',
            }
          }

          if (dayState.kind === 'reason') {
            return {
              background: 'repeating-linear-gradient(135deg, #e4e7ec 0, #e4e7ec 5px, #f8fafc 5px, #f8fafc 10px)',
              color: '#475467',
              textAlign: 'center',
              cursor: 'pointer',
              border: '1px solid #98a2b3',
            }
          }

          if (dayState.kind === 'planned') {
            return {
              background: '#b3e5fc',
              color: '#01579b',
              textAlign: 'center',
              cursor: 'pointer',
              border: '1px solid #81d4fa',
            }
          }

          // Пусто
          return {
            background: '#fff',
            color: '#333',
            textAlign: 'center',
            cursor: 'pointer',
            border: '1px solid #e0e0e0',
          }
        },
        valueFormatter: () => '',
        onCellClicked: (params) => {
          setSelectedDay(day)

          const year = graphData?.year
          const month = graphData?.month

          if (year && month) {
            const date = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`
            onSelectDate(date)
          }

          const bsiItems = getRealBsiItems(params.value)
          const dayState = getGraphDayState(params.value)

          if (bsiItems.length > 0 || ['reason', 'manual_planned', 'manual_outside_plan', 'ppk_pending'].includes(dayState.kind)) {
            setBsiDetails({
              type: bsiItems.length > 0
                ? 'bsi'
                : ['reason', 'manual_planned', 'manual_outside_plan', 'ppk_pending'].includes(dayState.kind) ? 'reason' : 'bsi',
              month: graphData?.month,
              year: graphData?.year,
              day,
              wellName: graphData?.graph?.well_name,
              items: bsiItems,
              value: params.value,
              reason: dayState.reason,
            })
          }
        },
      }
    })

    return [
      {
        headerName: 'Скважина',
        field: 'well',
        width: 120,
        pinned: 'left',
      },
      {
        headerName: 'Подрядчик',
        field: 'org',
        width: 180,
        pinned: 'left',
      },
      ...daysColumns,
    ]
  }, [selectedDay, graphData, onSelectDate])

  const rowData = useMemo(() => {
    if (!graphData) return []

    if (!graphData.found) {
      return []
    }

    const graph = graphData.graph

    const row = {
      well: graph.well_name,
      org: graph.org_name,
    }

    for (let day = 1; day <= 31; day++) {
      row[`d${day}`] = graph.days[String(day)]
    }

    return [row]
  }, [graphData])

  if (!wellId) {
    return null
  }

  if (graphData && !graphData.found) {
    return (
      <div style={emptyStyle}>
        Скважина не найдена в актуальном графике. Заявку можно создать вне графика.
      </div>
    )
  }

  return (
    <>
    <style>{gridCompactStyle}</style>
    <div style={{ margin: '14px' }}>
      <div style={{ marginBottom: '6px', fontSize: '13px', fontWeight: 'bold' }}>
        График скважины за актуальный месяц
      </div>

      <div
        className="ag-theme-alpine well-mini-grid"
        style={{
          height: 62,
          width: '100%',
        }}
      >
        <AgGridReact
            rowData={rowData}
            columnDefs={columnDefs}
            domLayout="normal"
            suppressRowHoverHighlight={true}
            headerHeight={22}
            rowHeight={24}
            suppressMenuHide={true}
          />
      </div>

      {bsiDetails && (
        <div style={modalOverlayStyle}>
          <div style={modalStyle}>
            <div style={modalTitleStyle}>
              {bsiDetails.type === 'reason' ? 'Ручная запись / причина' : 'БСИ'}: {bsiDetails.wellName}, {formatMonthLabel(bsiDetails)}, день {bsiDetails.day}
            </div>
            {bsiDetails.type === 'reason' ? (
              <div style={bsiDetailsStyle}>
                <div style={bsiItemStyle}>
                  <div style={bsiItemTitleStyle}>{formatNullable(bsiDetails.reason)}</div>
                  <div>ФИО: {formatNullable(bsiDetails.value?.fio)}</div>
                  <div>Экипаж: {formatNullable(bsiDetails.value?.equipage?.label)}</div>
                  <div>Интервал: {formatNullable(bsiDetails.value?.interval)}</div>
                  <div>Глубина: {formatNullable(bsiDetails.value?.depth)}</div>
                  <div>ППК: {formatPpkLimit(bsiDetails.value?.ppk_limit)}</div>
                  {bsiDetails.value?.ppk_pending && (
                    <div style={ppkPendingStyle}>ППК: {formatPendingPpk(bsiDetails.value.ppk_pending)}</div>
                  )}
                  {bsiDetails.value?.repair_info && (
                    <>
                      <div>Ремонт: {formatNullable(bsiDetails.value.repair_info.comment)}</div>
                      <div>Период ремонта: {formatRepairPeriod(bsiDetails.value.repair_info)}</div>
                      <div>Ответственный: {formatNullable(bsiDetails.value.repair_info.fio)}</div>
                    </>
                  )}
                </div>
              </div>
            ) : (
              <div style={bsiDetailsStyle}>
                {bsiDetails.items.map((item, index) => (
                  <div key={item.id || index} style={bsiItemStyle}>
                    <div style={bsiItemTitleStyle}>Проходка {index + 1}</div>
                    <div>Глубина: {formatNullable(item.depth)}</div>
                    <div>ППК: {formatNullable(item.ppk)}</div>
                    <div>Порог полного прохода: {formatPpkLimit(bsiDetails.value?.ppk_limit)}</div>
                    {bsiDetails.value?.ppk_pending && (
                      <div style={ppkPendingStyle}>ППК: {formatPendingPpk(bsiDetails.value.ppk_pending)}</div>
                    )}
                    <div>Уровень: {item.bsi_level?.name || '—'}</div>
                    <div>Начало спуска: {formatDateTime(item.descent_start) || '—'}</div>
                    <div>Конец спуска: {formatDateTime(item.descent_end) || '—'}</div>
                    <div>Спуск: {formatNullable(item.descent_total)}</div>
                    <div>Подъем: {formatNullable(item.lift_total)}</div>
                  </div>
                ))}
              </div>
            )}
            <div style={modalActionsStyle}>
              <button type="button" style={secondaryButtonStyle} onClick={() => setBsiDetails(null)}>
                Закрыть
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
    </>
  )
}

function formatNullable(value) {
  return value === null || value === undefined || value === '' ? '—' : value
}

function formatPpkLimit(ppkLimit) {
  if (!ppkLimit?.depth) return '900'

  return `${ppkLimit.depth} (акт ${ppkLimit.act || '—'}, утвержден ${ppkLimit.commit_date || '—'})`
}

function formatPendingPpk(ppkPending) {
  if (!ppkPending) return '—'

  return `есть в сводке ППК, но не подтверждена (глубина ${formatNullable(ppkPending.depth)}, акт ${formatShortFileName(ppkPending.act)}, дата ${ppkPending.date || '—'})`
}

function formatShortFileName(value) {
  if (!value) return '—'

  const fileName = String(value).split('/').pop() || String(value)
  if (fileName.length <= 14) return fileName

  return `${fileName.slice(0, 4)}...${fileName.slice(-7)}`
}

function formatRepairPeriod(repairInfo) {
  if (!repairInfo) return '—'

  return `${formatNullable(repairInfo.date_from)} - ${repairInfo.date_to ? formatNullable(repairInfo.date_to) : 'по настоящее время'}`
}

function formatDateTime(value) {
  if (!value) return ''

  return new Intl.DateTimeFormat('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(value))
}

function formatMonthLabel(details) {
  if (!details?.month || !details?.year) return 'актуальный месяц'

  const date = new Date(`${details.year}-${String(details.month).padStart(2, '0')}-01T00:00:00`)

  return new Intl.DateTimeFormat('ru-RU', {
    month: 'short',
    year: '2-digit',
  }).format(date)
}

const emptyStyle = {
  margin: '14px',
  padding: '10px',
  background: '#fff3cd',
  border: '1px solid #ffeeba',
  color: '#856404',
  fontSize: '13px',
}

const gridCompactStyle = `
  .well-mini-grid {
    --ag-font-size: 10px;
    --ag-header-height: 22px;
    --ag-row-height: 24px;
    scrollbar-gutter: stable;
  }

  .well-mini-grid .ag-body-horizontal-scroll {
    display: flex !important;
    height: 16px !important;
    min-height: 16px !important;
    max-height: 16px !important;
  }

  .well-mini-grid .ag-body-horizontal-scroll-viewport {
    overflow-x: scroll !important;
  }

  .well-mini-grid .ag-body-horizontal-scroll-viewport::-webkit-scrollbar {
    height: 14px;
  }

  .well-mini-grid .ag-body-horizontal-scroll-viewport::-webkit-scrollbar-track {
    background: #eef2f6;
    border-radius: 7px;
  }

  .well-mini-grid .ag-body-horizontal-scroll-viewport::-webkit-scrollbar-thumb {
    background: #98a2b3;
    border: 3px solid #eef2f6;
    border-radius: 7px;
  }

  .well-mini-grid .ag-body-horizontal-scroll-viewport::-webkit-scrollbar-thumb:hover {
    background: #667085;
  }

  .well-mini-grid .ag-header-cell {
    padding: 0 !important;
  }

  .well-mini-grid .graph-day-header .ag-header-cell-label {
    justify-content: center !important;
    padding: 0 !important;
  }

  .well-mini-grid .graph-day-header .ag-header-cell-text {
    text-align: center !important;
    width: 100%;
  }

  .well-mini-grid .graph-day-cell {
    align-items: center !important;
    justify-content: center !important;
    padding: 0 !important;
    text-align: center !important;
  }

  .well-mini-grid .ag-header-cell-label {
    justify-content: center !important;
    padding: 0 !important;
  }

  .well-mini-grid .ag-header-cell-text {
    font-size: 9px !important;
    line-height: 1 !important;
    font-weight: 600 !important;
  }

  .well-mini-grid .ag-cell {
    font-size: 9px !important;
    padding: 0 !important;
    line-height: 24px !important;
    text-align: center !important;
  }
`

const modalOverlayStyle = {
  position: 'fixed',
  inset: 0,
  background: 'rgba(0,0,0,0.35)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 1300,
}

const modalStyle = {
  width: '420px',
  maxWidth: 'calc(100vw - 32px)',
  background: '#fff',
  border: '1px solid #999',
  boxShadow: '0 8px 30px rgba(0,0,0,0.25)',
  padding: '14px',
  boxSizing: 'border-box',
}

const modalTitleStyle = {
  fontWeight: 700,
  fontSize: '15px',
}

const bsiDetailsStyle = {
  marginTop: '12px',
  display: 'grid',
  gap: '10px',
  maxHeight: '360px',
  overflowY: 'auto',
}

const bsiItemStyle = {
  padding: '10px',
  border: '1px solid #d0d5dd',
  borderRadius: '4px',
  background: '#f8fafc',
  lineHeight: 1.55,
  fontSize: '13px',
}

const bsiItemTitleStyle = {
  fontWeight: 700,
  marginBottom: '4px',
}

const ppkPendingStyle = {
  color: '#b42318',
  fontWeight: 700,
}

const modalActionsStyle = {
  display: 'flex',
  justifyContent: 'flex-end',
  marginTop: '12px',
}

const secondaryButtonStyle = {
  height: '32px',
  border: '1px solid #b8c0cc',
  background: '#fff',
  padding: '0 12px',
  cursor: 'pointer',
}


export default WellMonthAgGrid
